import { gql } from '@apollo/client';
import { useQueryCoordinate, useMutationCoordinate } from '../graphql.hooks';

export const RESTRICTIONS_GET = gql`
  query RestrictionsGet {
    restrictionsGet {
      restrictions {
        restrictionKey
        type
        value
        pollFrequency
        enabled
        stripeProductId
        createdAt
        updatedAt
      }
    }
  }
`;

export const RESTRICTION_GET = gql`
  query RestrictionGet($restrictionKey: Int!) {
    restrictionGet(restrictionKey: $restrictionKey) {
      restriction {
        restrictionKey
        type
        value
        pollFrequency
        enabled
        stripeProductId
        createdAt
        updatedAt
      }
    }
  }
`;

export const RESTRICTION_STATUSES_GET = gql`
  query RestrictionStatusesGet($input: RestrictionStatusesGetInput!) {
    restrictionStatusesGet(input: $input) {
      restrictionStatuses {
        restrictionStatusKey
        restrictionKey
        entityName
        entityKey
        status
        overrideValue
        createdAt
        updatedAt
      }
    }
  }
`;

export const RESTRICTION_UPDATE = gql`
  mutation RestrictionUpdate($input: RestrictionUpdateInput!) {
    restrictionUpdate(input: $input) {
      success
    }
  }
`;

export type Restriction = {
  restrictionKey: number;
  type: string;
  value: number;
  pollFrequency: number;
  enabled: boolean;
  stripeProductId: string | null;
  createdAt: string;
  updatedAt: string;
};

export type RestrictionStatusesGetInput = {
  restrictionKey?: number;
};

export type RestrictionStatus = {
  restrictionStatusKey: number;
  restrictionKey: number;
  entityName: string;
  entityKey: number;
  status: string;
  overrideValue: number;
  createdAt: string;
  updatedAt: string;
};

export type RestrictionsGetData = {
  restrictionsGet: {
    restrictions: Restriction[];
  };
};

export type RestrictionGetData = {
  restrictionGet: {
    restriction: Restriction;
  };
};

export type RestrictionStatusesGetData = {
  restrictionStatusesGet: {
    restrictionStatuses: RestrictionStatus[];
  };
};

export type RestrictionUpdateInput = {
  restrictionKey: number;
  value?: number;
  pollFrequency?: number;
  enabled?: boolean;
  stripeProductId?: string | null;
};

export type RestrictionUpdateData = {
  restrictionUpdate: {
    success: boolean;
  };
};

// Custom hooks
export const useRestrictionsGet = (options = {}) => {
  return useQueryCoordinate(RESTRICTIONS_GET, options);
};

export const useRestrictionGet = (restrictionKey: number, options = {}) => {
  return useQueryCoordinate(RESTRICTION_GET, { 
    ...options,
    variables: { restrictionKey }
  });
};

export const useRestrictionStatusesGet = (restrictionKey?: number, options: any = {}) => {
  return useQueryCoordinate(RESTRICTION_STATUSES_GET, {
    ...options,
    variables: {
      input: {
        restrictionKey
      }
    },
    skip: options.skip !== undefined ? options.skip : false
  });
};

export const useRestrictionUpdate = (options = {}) => {
  return useMutationCoordinate(RESTRICTION_UPDATE, options);
};